import { render, staticRenderFns } from "./checkoutV4.vue?vue&type=template&id=bd41c928&scoped=true"
import script from "./checkoutV4.vue?vue&type=script&lang=js"
export * from "./checkoutV4.vue?vue&type=script&lang=js"
import style0 from "./checkoutV4.vue?vue&type=style&index=0&id=bd41c928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd41c928",
  null
  
)

export default component.exports